import { serialize } from 'cookie';
import { ServerResponse } from 'http';

export const COOKIE_MOBILE_APP = 'mobile-app';
export const COOKIE_CONTEXT_HASH = 'context-hash';
export const COOKIE_USER_CONTEXT_HASH = {
  name: 'user-context-hash',
  options: {
    httpOnly: false,
  },
};

export type Cookie = {
  name: string;
  value?: string;
  options?: {
    path?: string;
    httpOnly?: boolean;
    secure?: boolean;
    maxAge?: number;
  };
};

const defaultCookieOptions = {
  path: '/',
  httpOnly: true,
  secure: true,
};

export const handleCookies = (res: ServerResponse, cookiesToSet: Cookie[], cookiesToDelete: Cookie[]) => {
  const deletedCookies = cookiesToDelete.map((cookie) =>
    serialize(cookie.name, '', { ...defaultCookieOptions, ...cookie.options, maxAge: -1 }),
  );
  const newCookies = cookiesToSet.map((cookie) =>
    serialize(cookie.name, cookie.value || '', { ...defaultCookieOptions, ...cookie.options }),
  );
  const allCookies = [...deletedCookies, ...newCookies];

  res.setHeader('Set-Cookie', allCookies);
};
